<template>
  <button
    v-if="!store.recording"
    :class="recordStyle"
    @click="store.P5Instance.startRecording()"
  >
    Record Video
  </button>
  <button
    v-if="store.recording"
    :class="recordStyle"
    @click="store.P5Instance.stopRecording()"
  >
    Stop Recording
  </button>
</template>

<script>
import { store } from "../../store";
export default {
  name: "RecordButton",
  data: () => ({ store }),
  computed: {
    recordStyle() {
      return {
        "active-red-btn ":
          store.exportOptions[0].name == "S" ||
          store.exportOptions[0].name == "M",
        "disabled-btn ":
          store.exportOptions[0].name == "L" ||
          store.exportOptions[0].name == "XL" || !store.runnerInstance.enabled,
      };
    },
  },
};
</script>